(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetasrealtimeDeleteController',ZetasrealtimeDeleteController);

    ZetasrealtimeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Zetasrealtime'];

    function ZetasrealtimeDeleteController($uibModalInstance, entity, Zetasrealtime) {
        var vm = this;

        vm.zetasrealtime = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Zetasrealtime.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
